/*
    Поле отвечает за определение виджета и трансляцию в форму событий изменения данных виджета
 */

import { createElement, useMemo } from 'react';

import { ApiDataType, FormDataType } from '@/types';

import { TField } from '../dto';
import { widgets as simpleWidgets } from './simpleWidgets';
import TextInput from './simpleWidgets/text-input/TextInput';
import { WidgetComponent } from './widget';

export type FieldComponent = {
	field: TField;
	disabled?: boolean;
	readOnly?: boolean;
	value?: string | number | string[] | null | Date;
	widgets?: { [value: string]: React.FC<WidgetComponent> };
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onChange: (value: any) => void;
	onSubmit?: (data: FormDataType, reset?: () => void) => void;
	resDataAfterSubmit?: ApiDataType | null;
	form?: string;
	className?: string;
};

const getWidgetComponent = (
	widgets: { [value: string]: React.FC<WidgetComponent> },
	field: TField
): React.FC<WidgetComponent> => {
	return widgets[field.type] || widgets.default || TextInput;
};

const Field = ({
	field,
	readOnly,
	disabled,
	value,
	widgets,
	onChange,
	onSubmit,
	resDataAfterSubmit,
	form,
	className,
}: FieldComponent) => {
	const Widget = useMemo(() => {
		if (widgets) {
			const widget = getWidgetComponent(widgets, field);
			if (widget) return widget;
		}

		const simpleWidget = getWidgetComponent(simpleWidgets, field);
		if (simpleWidget) return simpleWidget;

		return TextInput;
	}, [widgets, field]);

	const finalValue = value === undefined ? field.initial_value : value;

	return createElement(Widget, {
		form,
		name: field.name,
		label: field.label,
		placeholder: field.placeholder,
		helpText: field.helpText,
		disabled,
		readOnly,
		multiple: field.multiple,
		value: finalValue || '',
		onChange,
		choices: field.choices,
		choices_url: field.choices_url,
		fieldClass: field.fieldClass,
		required: field.required,
		rows: field.rows,
		onSubmit,
		resDataAfterSubmit,
		widgetArgs: field.widget_args,
		className,
	});
};

export default Field;
